import React from 'react';
import { FormField, EmailField, PhoneField, FileUpload } from 'components';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FaFileContract } from 'react-icons/fa';

function Corporation({
  onCorpChanged,
  name,
  affidavit,
  articles,
  onDeleteFile,
  user,
  onUserChanged,
  onFileChanged,
  errors,
}) {
  const handleCorpChanged = (state) => {
    onCorpChanged(state);
  };

  const handleFileSelected = (docType) => async (uploadedFile, fileType) => {
    onFileChanged(docType, uploadedFile, fileType);
  };

  const handleUserChanged = (state) => {
    const updateUser = { ...(user || {}) };
    updateUser[state.field] = state.value;
    onUserChanged(updateUser);
  };

  return (
    <div>
      <h6>Primary Owner</h6>
      <hr />

      <Row>
        <Col className='ms-1'>
          <FormField
            fieldId='orgName'
            label='Corporation or Organization Name'
            initialValue={name}
            onStateChanged={handleCorpChanged}
            required
            error={errors?.orgName}
          />
        </Col>
      </Row>
      <Row className='mb-4 ms-2 text-center'>
        <FileUpload
          className='ms-4'
          type='OTHER'
          icon={FaFileContract}
          title='Articles of Incorporation'
          file={articles}
          onFileSelected={handleFileSelected('articlesOfIncorporation')}
          deleteFile={() => onDeleteFile('articlesOfIncorporation')}
          height={150}
          width={150}
        />
        <FileUpload
          className='ms-4'
          type='OTHER'
          icon={FaFileContract}
          title='Authorized Signer Affidavit'
          file={affidavit}
          onFileSelected={handleFileSelected('signerAffidavit')}
          deleteFile={() => onDeleteFile('signerAffidavit')}
          height={150}
          width={150}
        />
      </Row>

      <label className='control-label ms-4'>Corporation or Organization Contact*</label>

      <Row>
        <Col sm={6}>
          <FormField
            fieldId='firstName'
            label=''
            placeholder='First Name'
            initialValue={user?.firstName}
            onStateChanged={handleUserChanged}
            required
            error={errors?.firstName}
          />
        </Col>
        <Col sm={6}>
          <FormField
            fieldId='lastName'
            label=''
            placeholder='Last Name'
            initialValue={user?.lastName}
            onStateChanged={handleUserChanged}
            required
            error={errors?.lastName}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <PhoneField
            fieldId='phone'
            label='Mobile'
            value={user?.phone || ''}
            onChange={handleUserChanged}
            error={errors?.phone}
          />
        </Col>
        <Col sm={6}>
          <EmailField
            fieldId='email'
            label='Email Address'
            initialValue={user?.email || ''}
            onStateChanged={handleUserChanged}
            required
            error={errors?.email}
          />
        </Col>
      </Row>
    </div>
  );
}

export default Corporation;
